import { useSyncExternalStore } from 'react';

/**
 * One clock for every live duration on the deployment pages. A running
 * deploy's "total 51m 37s" ticks each second from this, with a single timer
 * however many rows and cards are counting.
 */
let now = Date.now();
const listeners = new Set<() => void>();

function tick() {
  now = Date.now();
  for (const listener of listeners) listener();
}

setInterval(tick, 1000);
// A hidden tab's timers slow right down. Catch up the moment the person comes back.
if (typeof document !== 'undefined') document.addEventListener('visibilitychange', tick);

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const noSubscription = () => () => {};
const getNow = () => now;

/**
 * The time now. While `active` the component re-renders each second. Pass
 * false for a finished run: its duration never changes, so it must not tick.
 */
export function useDeployClock(active = true): number {
  return useSyncExternalStore(active ? subscribe : noSubscription, getNow, getNow);
}
